import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import style from "./NewLearningDetail.module.css";
import LeftArrow from "../../assests/LeftArrow.png";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { baseurl } from "../Url";
import Loader from "../Loder/Loader";
import { useSelector } from "react-redux";
import { GrFormPrevious } from "react-icons/gr";
import { GrFormNext } from "react-icons/gr";
import ChatPopup from "../ChatPopup/ChatPopup";
import { BsRobot } from "react-icons/bs";
import { IoChevronBack } from "react-icons/io5";
import { PiClipboardText, PiListChecks, PiProjectorScreen, PiVideoCamera } from "react-icons/pi";
import { VscGraph } from "react-icons/vsc";
import { FiFilter } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import { MdFullscreen } from "react-icons/md";
import LearningBottomNav from "../LearningBottomNav/LearningBottomNav";
import { useLearning } from "../Context/LearningContext";
import Whiteboard from '../WhiteBoard/WhiteBoard';
import { generateMeetingUrl } from '../GoogleMeet';
import { BiClipboard } from "react-icons/bi";
import { SiGooglemeet } from "react-icons/si";

const formatUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${baseurl}/${url}`;
};

const NewLearningDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateLearningData, learningData } = useLearning();

  const state = location.state;
  const backNavigationState = {
    learning_detail: state?.learning_detail,
    peerRole: state?.peerRole,
    returnPath: state?.returnPath,
  };
  // Merge router state with LearningContext + localStorage so /ai/lesson/generation/for/user runs
  // even if a caller used the wrong key (e.g. mainId vs mainID) or user returns via bottom nav.
  const Topic = state?.singleTopic ?? learningData?.singleTopic;
  const learning_id = state?.learning ?? learningData?.learning;
  const admin_Mapped_Lessons = state?.mapped ?? learningData?.mapped;
  const topicNo = state?.topicNo ?? state?.topic_no ?? learningData?.topicNo;
  const [isChatPopupVisible, setChatPopupVisible] = useState(false);
  const key = JSON.parse(localStorage.getItem("access-token"));
  const USERID = localStorage.getItem("USERID");
  const OrgID = localStorage.getItem("ORGID");
  const maintopic_id =
    state?.mainID ??
    state?.mainId ??
    learningData?.mainID ??
    localStorage.getItem("main_topic_id");

  const topicId = Topic?.id || Topic?.topic_id || Topic?._id;
  const topicName = Topic?.value || Topic?.name || Topic?.topic_name || "";

  // Function to toggle ChatPopup visibility
  const openChatPopup = () => setChatPopupVisible(true);
  const closeChatPopup = () => setChatPopupVisible(false);

  const {
    userDetails,
    status: userStatus,
    error: userError,
  } = useSelector((state) => state.user);

  const [AiId, setAiID] = useState("");
  const [topicDataList, setTopicDataList] = useState([]);
  const [assessmentData, setAssessmentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [trialUser, setTrailUser] = useState(false);
  const [assessmentExist, setAssessmentExist] = useState(false);
  const [assessmentInfo, setAssessmentInfo] = useState(null);
  const [uniqueId, setUniqueId] = useState(false);
  const [current, setCurrent] = useState(1);
  const [type, setType] = useState("");
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [roomID, setRoomID] = useState("");
  const [visibleCount, setVisibleCount] = useState(8);
  const [viewMode, setViewMode] = useState("paging"); // 'paging' | 'scrolling' — default: Pages view
  const [whiteBoradShow, setWhiteBoardShow] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (state) {
      if (maintopic_id) {
        localStorage.setItem("main_topic_id", String(maintopic_id));
      }
      updateLearningData({
        singleTopic: state.singleTopic,
        learning: state.learning,
        mapped: state.mapped,
        topicNo: state.topicNo ?? state.topic_no,
        mainID: state?.mainID ?? state?.mainId ?? maintopic_id,
      });
    }
  }, [state, maintopic_id]);
  const [expandedSlides, setExpandedSlides] = useState({});
  const [showReadMoreMap, setShowReadMoreMap] = useState({});
  const [activeSlide, setActiveSlide] = useState(0);
  const [showFilters, setShowFilters] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const contentAreaRef = useRef(null);
  const slideRefs = useRef([]);
  const lessonPreferredTypes = new Set([
    "uploaded lesson",
    "ai_generated_text",
    "use case",
    "questions",
  ]);
  const lessonOnlySlides = topicDataList.filter((item) => lessonPreferredTypes.has(item?.type));
  const pagingSlides =
    viewMode === "paging"
      ? (type ? topicDataList : (lessonOnlySlides.length > 0 ? lessonOnlySlides : topicDataList))
      : topicDataList;
  const safeActiveSlide = Math.min(activeSlide, Math.max(pagingSlides.length - 1, 0));
  const carouselTouchRef = useRef({
    x: 0,
    y: 0,
    scrollLeft: 0,
    axis: "undecided",
  });

  const handlePreviewPrev = () => {
    setActiveSlide((prev) => Math.max(0, prev - 1));
  };

  const handlePreviewNext = () => {
    setActiveSlide((prev) => Math.min(pagingSlides.length - 1, prev + 1));
  };

  // Keyboard controls for fullscreen preview
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isPreviewOpen) return;

      if (e.key === "Escape") {
        setIsPreviewOpen(false);
        return;
      }

      if (viewMode !== "paging" || pagingSlides.length <= 1) return;

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        handlePreviewPrev();
      }

      if (e.key === "ArrowRight") {
        e.preventDefault();
        handlePreviewNext();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isPreviewOpen, viewMode, pagingSlides.length]);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) {
      setShowReadMoreMap({});
      return;
    }

    const checkOverflow = () => {
      const newMap = {};
      const mobileNow = window.innerWidth <= 768;
      topicDataList.forEach((_, index) => {
        if (slideRefs.current[index] && !expandedSlides[index]) {
          const isPaging = viewMode === 'paging';
          const threshold = mobileNow ? 550 : 800;
          newMap[index] =
            slideRefs.current[index].scrollHeight > threshold && (mobileNow || isPaging);
        }
      });
      setShowReadMoreMap(newMap);
    };

    checkOverflow();
    const timer = setTimeout(checkOverflow, 200);
    let resizeDebounce;
    const onResize = () => {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(checkOverflow, 150);
    };
    window.addEventListener('resize', onResize);
    return () => {
      clearTimeout(timer);
      clearTimeout(resizeDebounce);
      window.removeEventListener('resize', onResize);
    };
  }, [topicDataList, expandedSlides, activeSlide, visibleCount, viewMode]);

  /* Mobile horizontal lesson strip: parent scroll + nested overflow often eat the first swipe.
     After locking to horizontal, preventDefault so the track (not the page) owns the gesture. */
  useEffect(() => {
    const el = contentAreaRef.current;
    if (!el) return;

    const canCarouselSwipe = () =>
      typeof window !== "undefined" &&
      window.innerWidth <= 768 &&
      viewMode === "scrolling" &&
      topicDataList.length > 1;

    const onTouchStart = (e) => {
      if (!canCarouselSwipe()) return;
      const t = e.touches[0];
      carouselTouchRef.current = {
        x: t.clientX,
        y: t.clientY,
        scrollLeft: el.scrollLeft,
        axis: "undecided",
      };
    };

    const onTouchMove = (e) => {
      if (!canCarouselSwipe()) return;
      const t = e.touches[0];
      const st = carouselTouchRef.current;
      const dx = t.clientX - st.x;
      const dy = t.clientY - st.y;

      if (st.axis === "undecided") {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        st.axis = Math.abs(dx) > Math.abs(dy) ? "h" : "v";
      }

      if (st.axis === "h") {
        e.preventDefault();
        el.scrollLeft = st.scrollLeft - dx;
      }
    };

    const onTouchEnd = () => {
      carouselTouchRef.current.axis = "undecided";
    };

    el.addEventListener("touchstart", onTouchStart, { passive: true });
    el.addEventListener("touchmove", onTouchMove, { passive: false });
    el.addEventListener("touchend", onTouchEnd);
    el.addEventListener("touchcancel", onTouchEnd);

    return () => {
      el.removeEventListener("touchstart", onTouchStart);
      el.removeEventListener("touchmove", onTouchMove);
      el.removeEventListener("touchend", onTouchEnd);
      el.removeEventListener("touchcancel", onTouchEnd);
    };
  }, [viewMode, topicDataList.length]);

  // Scroll to top when activeSlide changes in paging mode
  useEffect(() => {
    if (viewMode === 'paging' && contentAreaRef.current) {
      const resetScroll = () => {
        if (contentAreaRef.current) {
          contentAreaRef.current.scrollTop = 0;
        }
      };
      resetScroll();
      // Small delay to ensure content is fully rendered before scroll reset
      const timer = setTimeout(resetScroll, 50);
      return () => clearTimeout(timer);
    }
  }, [activeSlide, viewMode]);

  useEffect(() => {
    setActiveSlide(0);
  }, [type, viewMode]);

  useEffect(() => {
    if (activeSlide > pagingSlides.length - 1) {
      setActiveSlide(0);
    }
  }, [activeSlide, pagingSlides.length]);

  const toggleExpand = (index) => {
    setExpandedSlides(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleScroll = (e) => {
    if (window.innerWidth > 768) return;
    // Paging mode renders a single slide; index is driven by Prev/Next only. Syncing from
    // scrollLeft here would force activeSlide to 0 whenever scrollLeft is 0 and break navigation.
    if (viewMode === "paging") return;

    const track = e.currentTarget;
    const scrollLeft = track.scrollLeft;
    const children = track.children;
    if (!children.length || topicDataList.length === 0) return;

    const first = children[0];
    const gap = 12; /* must match .contentGrid.swipable gap in NewLearningDetail.module.css */
    const step = first.offsetWidth + gap;
    if (step <= 0) return;

    const maxIdx = topicDataList.length - 1;
    let newIndex = Math.round(scrollLeft / step);
    newIndex = Math.max(0, Math.min(newIndex, maxIdx));

    setActiveSlide((prev) => (newIndex !== prev ? newIndex : prev));
  };

  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      if (width < 600) {
        setVisibleCount(3);
      } else if (width < 1024) {
        setVisibleCount(5);
      } else {
        setVisibleCount(8);
      }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const startMeeting = () => {
    try {
      const meetingUrl = generateMeetingUrl();
      window.open(meetingUrl, '_blank');
    } catch (error) {
      console.error('Error starting meeting:', error);
    }
  };

  const handleCloseWhiteboard = () => {
    setClosing(true);
    setTimeout(() => {
      setWhiteBoardShow(false);
      setClosing(false);
    }, 500);
  };

  const buttons = [
    { label: "All", type: "" },
    { label: "Notes", type: "uploaded lesson" },
    { label: "Images", type: "image" },
    { label: "Videos", type: "video_url" },
    { label: "PDF", type: "pdf" },
    { label: "AI Lessons", type: "ai_generated_text" },
    { label: "Questions", type: "questions" },
    { label: "Use-Case", type: "use case" },
    { label: "Summary", type: "summary" },
  ];

  const visibleButtons = buttons.slice(startIndex, startIndex + visibleCount);

  const handleNext = () => {
    if (startIndex + visibleCount < buttons.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  async function Topic_Single() {
    try {
      const res = await fetch(`${baseurl}/ai/lesson/generation/for/user`, {
        method: "POST",
        body: JSON.stringify({
          Organization_ID: OrgID,
          topic_id: topicId,
          topic_name: topicName,
          learning_id: learning_id,
          main_topic_id: maintopic_id,
          user_id: USERID,
          admin_mapped: admin_Mapped_Lessons,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data.status && data.data?.length > 0) {
        setAiID(data.data[0]?.ai_id);
        setRoomID(data.data[0]?.room_id);

        let hasAssessment = false;
        if (data.data[0]?.assessments?.length > 0) {
          hasAssessment = true;
          setAssessmentExist(true);
          setAssessmentInfo(data.data[0].assessments[0]);
        } else {
          setAssessmentExist(false);
          setAssessmentInfo(null);
        }

        // Check for tasks
        const taskRes = await fetch(`${baseurl}/task/list/all`, {
          method: "POST",
          body: JSON.stringify({
            org_id: OrgID,
            main_topic_id: maintopic_id,
            topic_id: topicId
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const taskData = await taskRes.json();
        const hasTasks = taskData.data && taskData.data.tasks && taskData.data.tasks.length > 0;

        // Auto-complete if no assessments and no tasks
        if (!hasAssessment && !hasTasks) {
          console.log("Auto-completing topic as no assessments or tasks found.");
          await fetch(`${baseurl}/userlearning/topic/mark-complete`, {
            method: "POST",
            body: JSON.stringify({
              user_id: USERID,
              org_id: OrgID,
              topic_id: topicId,
              main_topic_id: maintopic_id,
              learning_id: learning_id
            }),
            headers: {
              "Content-Type": "application/json",
            },
          });
        }

        updateLearningData({
          aiID: data.data[0]?.ai_id,
          roomID: data.data[0]?.room_id,
          assessmentExist: hasAssessment,
          assessmentInfo: hasAssessment ? data.data[0].assessments[0] : null
        });
      } else {
        // Handle case where no AI content is generated
        setAiID("");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error in Topic_Single:", error);
      setLoading(false);
    }
  }

  async function dataGet(page) {
    setLoading(true);
    try {
      const res = await fetch(`${baseurl}/pagination/filter-pages`, {
        method: "POST",
        body: JSON.stringify({
          Organization_ID: OrgID,
          ai_id: AiId,
          user_id: USERID,
          type: type,
          current_page_index: page,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${key}`,
        },
      });
      const data = await res.json();
      if (data.status === true) {
        const newData = data.data?.[0] || {};
        setTopicDataList((prev) => (page === 1 ? [newData] : [...prev, newData]));
        setUniqueId(data.data?.[0]?.unique_id || null);
        setTotalNoOfPages(data.total_pages);

        // Fetch next page if available
        if (page < data.total_pages) {
          dataGet(page + 1);
        }
      } else {
        if (page === 1) setTopicDataList([]);
      }
    } catch (error) {
      console.error("Error fetching lesson data:", error);
      if (page === 1) setTopicDataList([]);
    } finally {
      setLoading(false);
    }
  }

  async function previousDetails() {
    await fetch(`${baseurl}/summary/previous-attended/`, {
      method: "POST",
      body: JSON.stringify({
        user_id: USERID,
        topic_id: topicId,
        main_topic_id: maintopic_id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setAssessmentData(data.summary || {});
        } else {
          setAssessmentData({});
        }
      });
  }

  useEffect(() => {
    if (AiId !== "") {
      dataGet(current);
    }
  }, [AiId]);

  useEffect(() => {
    if (!topicId || !learning_id || !OrgID || !USERID || !maintopic_id) {
      setLoading(false);
      return;
    }
    Topic_Single();
    // Re-run when identity of lesson/topic changes (not whole location.state object)
  }, [topicId, learning_id, maintopic_id, OrgID, USERID]);

  useEffect(() => {
    if (AiId && AiId !== "") {
      previousDetails();
    }
  }, [AiId]);

  useEffect(() => {
    const userType = userStatus === "succeeded" && userDetails && userDetails.user_type;
    setTrailUser(userType === "Trail");
  }, [userStatus, userDetails]);

  useEffect(() => {
    setCurrent(1);
    setTopicDataList([]);
    if (AiId) dataGet(1);
  }, [type]);



  return (
    <div className={style.container}>
      {loading && current === 1 ? (
        <Loader />
      ) : (
        <>
          <div className={style.header}>
            <div className={style.headerDesktop}>
              <div className={style.headerLeft}>
                <button className={style.backButton} onClick={() => navigate('/lerning/detail', { state: backNavigationState })}>
                  <IoChevronBack />
                </button>
                <div className={style.headerTitle}>
                  <div className={style.titleWithBack}>
                    <h1>{Topic?.value}</h1>
                  </div>
                  <p className={style.breadcrumb}>Skills / Lesson</p>
                </div>
              </div>
              <div className={style.headerActions}>
                <button
                  className={`${style.mobileFilterBtn} ${showFilters ? style.filterBtnActive : ""}`}
                  onClick={() => setShowFilters((prev) => !prev)}
                  title={showFilters ? "Hide filters" : "Show filters"}
                  aria-label={showFilters ? "Hide filters" : "Show filters"}
                >
                  <FiFilter />
                </button>
                <button
                  className={style.previewAllBtn}
                  onClick={() => setIsPreviewOpen(true)}
                >
                  Preview
                </button>
              </div>
              <div className={style.headerTopRow}>
                <div className={style.premiumToggle}>
                  <div
                    className={`${style.toggleSlider} ${viewMode === 'paging' ? style.onPaging : style.onScrolling}`}
                  />
                  <button
                    className={`${style.toggleOption} ${viewMode === 'paging' ? style.activeOption : ''}`}
                    onClick={() => setViewMode('paging')}
                  >
                    <PiClipboardText className={style.toggleIcon} />
                    <span>Pages</span>
                  </button>
                  <button
                    className={`${style.toggleOption} ${viewMode === 'scrolling' ? style.activeOption : ''}`}
                    onClick={() => setViewMode('scrolling')}
                  >
                    <PiListChecks className={style.toggleIcon} />
                    <span>Scroll</span>
                  </button>
                </div>
              </div>
            </div>

            <div className={style.headerMobile}>
              <div className={style.mobileHeaderTopBar}>
                <Link
                  to="/lerning/detail"
                  state={backNavigationState}
                  className={style.mobileBackLink}
                  aria-label="Back to lessons"
                >
                  <IoChevronBack size={16} aria-hidden className={style.mobileBackLinkIcon} />
                  <span>Back</span>
                </Link>
              </div>
              <div className={style.mobileHeaderTitleRow}>
                <div className={style.mobileHeaderTitle}>
                  <h1>{Topic?.value}</h1>
                </div>
              </div>
              <p className={`${style.breadcrumb} ${style.mobileBreadcrumb}`}>Skills / Lesson</p>
              <div className={style.mobilePreviewToggleRow}>
                <div className={style.mobilePreviewLeading}>
                  <button
                    type="button"
                    className={`${style.mobileFilterBtn} ${showFilters ? style.filterBtnActive : ""}`}
                    onClick={() => setShowFilters((prev) => !prev)}
                    title={showFilters ? "Hide filters" : "Show filters"}
                    aria-label={showFilters ? "Hide filters" : "Show filters"}
                  >
                    <FiFilter />
                  </button>
                  <button
                    type="button"
                    className={style.mobilePreviewWideBtn}
                    onClick={() => setIsPreviewOpen(true)}
                  >
                    Preview
                  </button>
                </div>
                <div className={style.premiumToggle}>
                  <div
                    className={`${style.toggleSlider} ${viewMode === 'paging' ? style.onPaging : style.onScrolling}`}
                  />
                  <button
                    type="button"
                    className={`${style.toggleOption} ${viewMode === 'paging' ? style.activeOption : ''}`}
                    onClick={() => setViewMode('paging')}
                  >
                    <PiClipboardText className={style.toggleIcon} />
                    <span>Pages</span>
                  </button>
                  <button
                    type="button"
                    className={`${style.toggleOption} ${viewMode === 'scrolling' ? style.activeOption : ''}`}
                    onClick={() => setViewMode('scrolling')}
                  >
                    <PiListChecks className={style.toggleIcon} />
                    <span>Scroll</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className={style.lessonContent}>
            {showFilters && (
            <div className={style.filterSection}>
              <div className={style.filterScroll}>
                <button
                  className={style.scrollBtn}
                  onClick={handlePrev}
                  disabled={startIndex === 0}
                >
                  <GrFormPrevious />
                </button>
                <div className={style.filterTabs}>
                  {visibleButtons.map((btn, idx) => (
                    <button
                      key={idx}
                      className={type === btn.type ? style.activeTab : style.tab}
                      onClick={() => setType(btn.type)}
                    >
                      {btn.label}
                    </button>
                  ))}
                </div>
                <button
                  className={style.scrollBtn}
                  onClick={handleNext}
                  disabled={startIndex + visibleCount >= buttons.length}
                >
                  <GrFormNext />
                </button>
              </div>
            </div>
            )}

            <div className={style.mainContentArea}>
              <div className={style.contentSection}>
                <button
                  className={style.mobilePreviewIcon}
                  onClick={() => setIsPreviewOpen(true)}
                  title="Preview All"
                >
                  <MdFullscreen />
                </button>
                <div
                  className={`${style.contentGridContainer} ${topicDataList.length === 0 ? style.contentGridContainerEmpty : ""}`}
                >
                  <div
                    className={`${style.contentGrid} ${style.swipable} ${viewMode === 'paging' ? style.pagingMode : style.scrollingMode}`}
                    ref={contentAreaRef}
                    onScroll={handleScroll}
                  >
                    {topicDataList.length > 0 ? (
                      (viewMode === 'paging'
                        ? [pagingSlides[safeActiveSlide]]
                        : topicDataList
                      ).map((content, index) => {
                        const actualIndex = viewMode === 'paging' ? safeActiveSlide : index;
                        if (!content) return null;
                        return (
                          <div
                            className={`${style.contentCard} ${style.slide} ${expandedSlides[actualIndex] ? style.isExpanded : style.isCollapsed}`}
                            key={actualIndex}
                            ref={(el) => (slideRefs.current[actualIndex] = el)}
                          >
                            {viewMode === 'paging' && pagingSlides.length > 1 && (
                              <div className={style.paginationPremium}>
                                <button
                                  className={style.navCircle}
                                  onClick={handlePreviewPrev}
                                  disabled={safeActiveSlide === 0}
                                >
                                  <GrFormPrevious />
                                  <span className={style.navText}>Prev</span>
                                </button>
                                <div className={style.pageIndicatorPremium}>
                                  <span className={style.currentIdx}>{safeActiveSlide + 1}</span>
                                  <span className={style.totalIdx}> / {pagingSlides.length}</span>
                                </div>
                                <button
                                  className={style.navCircle}
                                  onClick={handlePreviewNext}
                                  disabled={safeActiveSlide === pagingSlides.length - 1}
                                >
                                  <span className={style.navText}>Next</span>
                                  <GrFormNext />
                                </button>
                              </div>
                            )}
                            {content.type === "image" ? (
                              <div className={style.imageCard}>
                                {content.title && <h3>{content.title}</h3>}
                                <img src={formatUrl(content.text)} alt="Lesson" />
                              </div>
                            ) : content.type === "video_url" ? (
                              <div className={style.videoCard}>
                                {content.title && <h3>{content.title}</h3>}
                                <video controls width="100%">
                                  <source src={formatUrl(content.text)} type="video/mp4" />
                                </video>
                              </div>
                            ) : content.type === "pdf" ? (
                              <div className={style.pdfCard}>
                                {content.title && <h3>{content.title}</h3>}
                                <iframe src={formatUrl(content.text)} title="PDF Viewer" width="100%" height="500px" />
                                <div className={style.pdfLinks}>
                                  <a href={formatUrl(content.text)} target="_blank" rel="noreferrer">Open PDF</a>
                                </div>
                              </div>
                            ) : (
                              <div
                                className={style.textCard}
                              >
                                {content.title && <h3>{content.title}</h3>}
                                <div
                                  className={style.textContent}
                                  dangerouslySetInnerHTML={{ __html: content.text }}
                                />
                              </div>
                            )}

                            {showReadMoreMap[actualIndex] && !expandedSlides[actualIndex] && (
                              <div className={style.fadeOverlay}>
                                <button className={style.readMoreBtn} onClick={() => toggleExpand(actualIndex)}>
                                  Read More
                                </button>
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div className={style.noContent}>
                        <div className={style.noContentInner}>
                          <div className={style.noContentBadge} aria-hidden="true">i</div>
                          <p className={style.noContentTitle}>No lesson content available</p>
                          <p className={style.noContentHint}>Try selecting another module or changing the filter.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className={style.expansionActions}>
                </div>
              </div>

              <div className={style.premiumSidebar}>
                <div className={style.sidebarIcons}>
                  <button
                    className={style.premiumSideBtn}
                    onClick={() => navigate("/activity", {
                      state: { aiID: AiId, singleTopic: Topic, mapped: admin_Mapped_Lessons, learning: learning_id, mainID: maintopic_id, topicNo, uniqueId, roomID, assessmentExist }
                    })}
                  >
                    <div className={style.iconGlow} />
                    <PiListChecks />
                    <span className={style.hoverLabel}>Tasks</span>
                  </button>
                  <button
                    className={style.premiumSideBtn}
                    onClick={() => navigate("/assessments", {
                      state: { aiID: AiId, singleTopic: Topic, mapped: admin_Mapped_Lessons, learning: learning_id, mainID: maintopic_id, topicNo, assessmentExist }
                    })}
                  >
                    <div className={style.iconGlow} />
                    <PiClipboardText />
                    <span className={style.hoverLabel}>Assessments</span>
                  </button>
                  <button
                    className={style.premiumSideBtn}
                    onClick={() => navigate("/insights", {
                      state: { aiID: AiId, singleTopic: Topic, mapped: admin_Mapped_Lessons, learning: learning_id, mainID: maintopic_id, topicNo, roomID, assessmentExist }
                    })}
                  >
                    <div className={style.iconGlow} />
                    <VscGraph />
                    <span className={style.hoverLabel}>Analytics</span>
                  </button>
                  <button
                    className={style.premiumSideBtn}
                    onClick={openChatPopup}
                  >
                    <div className={style.iconGlow} />
                    <BsRobot />
                    <span className={style.hoverLabel}>AI Tutor</span>
                  </button>
                  <button
                    className={style.premiumSideBtn}
                    onClick={() => {
                      setWhiteBoardShow(true);
                    }}
                  >
                    <div className={style.iconGlow} />
                    <BiClipboard />
                    <span className={style.hoverLabel}>Whiteboard</span>
                  </button>
                  <button
                    className={style.premiumSideBtn}
                    onClick={startMeeting}
                  >
                    <div className={style.iconGlow} />
                    <SiGooglemeet />
                    <span className={style.hoverLabel}>Meeting</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {pagingSlides.length > 1 && !isChatPopupVisible && (
            <div className={style.pageIndicator}>
              {pagingSlides.map((_, idx) => (
                <div
                  key={idx}
                  className={`${style.dot} ${safeActiveSlide === idx ? style.activeDot : ""}`}
                />
              ))}
            </div>
          )}


          {isChatPopupVisible && (
            <ChatPopup
              token={key}
              UserName={userDetails?.name}
              setChatIcon={closeChatPopup}
              aiID={AiId}
              singleTopic={Topic}
              mapped={admin_Mapped_Lessons}
              learning={learning_id}
              mainID={maintopic_id}
              topicNo={topicNo}
              roomID={roomID}
            />
          )}

          <LearningBottomNav
            aiID={AiId}
            singleTopic={Topic}
            mapped={admin_Mapped_Lessons}
            learning={learning_id}
            mainID={maintopic_id}
            topicNo={topicNo}
            uniqueId={uniqueId}
            roomID={roomID}
            assessmentExist={assessmentExist}
          />

          {/* Fullscreen Preview Modal — rendered via portal to escape overflow container */}
          {isPreviewOpen && ReactDOM.createPortal(
            <div className={style.fsOverlay} onClick={() => setIsPreviewOpen(false)}>
              <div className={style.fsModal} onClick={(e) => e.stopPropagation()}>
                <div className={style.fsHeader}>
                  <h2 className={style.fsTitle}>{topicName || "Preview"}</h2>
                  <button className={style.fsClose} onClick={() => setIsPreviewOpen(false)}>
                    <IoMdClose />
                  </button>
                </div>
                <div className={style.fsBody}>
                  {(viewMode === 'paging'
                    ? [pagingSlides[safeActiveSlide]]
                    : topicDataList
                  ).map((content, idx) => {
                    const actualIdx = viewMode === 'paging' ? safeActiveSlide : idx;
                    return (
                      <div key={actualIdx} className={style.fsItem}>
                        {content.title && <h3 className={style.fsItemTitle}>{content.title}</h3>}
                        {content.type === "image" ? (
                          <img
                            src={formatUrl(content.text)}
                            alt="Lesson"
                            className={style.fsImage}
                          />
                        ) : content.type === "video_url" ? (
                          <video controls className={style.fsVideo}>
                            <source src={formatUrl(content.text)} type="video/mp4" />
                          </video>
                        ) : content.type === "pdf" ? (
                          <iframe
                            src={formatUrl(content.text)}
                            title="PDF Viewer"
                            className={style.fsPdf}
                          />
                        ) : (
                          <div
                            className={style.fsText}
                            dangerouslySetInnerHTML={{ __html: content.text }}
                          />
                        )}
                        {idx < (viewMode === 'paging' ? 1 : topicDataList.length) - 1 && <div className={style.fsSeparator} />}
                      </div>
                    );
                  })}
                </div>
                {viewMode === 'paging' && pagingSlides.length > 1 && (
                  <div className={style.fsPagination}>
                    <button
                      className={style.fsNavBtn}
                      onClick={handlePreviewPrev}
                      disabled={safeActiveSlide === 0}
                    >
                      <GrFormPrevious /> Prev
                    </button>
                    <span className={style.fsPageNum}>{safeActiveSlide + 1} / {pagingSlides.length}</span>
                    <button
                      className={style.fsNavBtn}
                      onClick={handlePreviewNext}
                      disabled={safeActiveSlide === pagingSlides.length - 1}
                    >
                      Next <GrFormNext />
                    </button>
                  </div>
                )}
              </div>
            </div>,
            document.body
          )}

          {whiteBoradShow && (
            <div className={`${style.WhiteBoradContainer} ${closing ? style.closing : ''}`}>
              <div className={style.WhiteBoradHead}>
                <div className={style.HeadText}>
                  White Board
                </div>
                <div
                  className={style.WhiteBoradIcon}
                  onClick={handleCloseWhiteboard}
                >
                  <IoMdClose />
                </div>
              </div>
              <div className={style.WhiteBoradContent} >
                <Whiteboard />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NewLearningDetail;
